import { render, staticRenderFns } from "./FieldForm.vue?vue&type=template&id=973002e4&"
import script from "./FieldForm.vue?vue&type=script&lang=js&"
export * from "./FieldForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports